import { useEffect, useRef, useCallback } from "react";

export const useOnFocus = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback: (args?: any) => void,
  duration: number = 0,
) => {
  const futureTimeRef = useRef<Date | null>(null);
  const handleFocusOrVisibilityChange = useCallback(() => {
    const now = new Date();
    if (document.visibilityState === "visible") {
      if (futureTimeRef.current !== null && now > futureTimeRef.current) {
        callback();
      }
      futureTimeRef.current = null;
    } else {
      futureTimeRef.current = new Date(now.getTime() + duration * 60 * 1000);
    }
  }, [callback, duration]);

  useEffect(() => {
    window.addEventListener("focus", handleFocusOrVisibilityChange);
    document.addEventListener(
      "visibilitychange",
      handleFocusOrVisibilityChange,
    );

    return () => {
      window.removeEventListener("focus", handleFocusOrVisibilityChange);
      document.removeEventListener(
        "visibilitychange",
        handleFocusOrVisibilityChange,
      );
    };
  }, [handleFocusOrVisibilityChange]);
};
